import { OrdersService } from 'src/app/core/services/selfcare/orders.service';
import { Component, Output, EventEmitter} from '@angular/core';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AuthData } from './core/data/AuthData';
import { order } from './core/models/sales/sales-orderProcessing';
import { Packages } from './core/models/sales/sales-makerGeoLocation';
import { AddonsDto, ProductDto } from './core/models/sales/sales-products-addons';
import { CartService } from './core/services/shared-services/cart.service';
import { UtilityService } from './core/services';
import { ApiConfig } from './core/apiConfig';
import { environment } from "../environments/environment";
import { NotificationService } from './core/services/shared-services/notification/notification.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-topbar',
    template: `
    <div class="layout-topbar">
      <div class="layout-topbar-left">
        <a class="topbar-menu-button" (click)="handleTobbarSidebarToggle()" >
                <i class="pi pi-bars"></i>
                </a>
        <!-- <div class="topbar-search">
                    <input type="text" placeholder="Search" />
                    <i class="pi pi-search"></i>
                </div> -->
      </div>
      <div class="layout-topbar-right">
        <ul class="layout-topbar-right-items">
          <li>
            <app-language-changer />
          </li>
          <li
  *ngIf="!isEnterpriseSim"
  class="notification"
  #notification
  [ngClass]="{
    'active-topmenuitem': appMain.activeTopbarItem === notification
  }"
>
            <a href="#" (click)="appMain.onTopbarItemClick($event, notification)">
              <i class="topbar-icon pi pi-fw pi-bell"></i>
              <span class="topbar-badge">{{ notificationCount }}</span>
            </a>
            <ul class="fadeInDown">
              <div class="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom-1 border-50">
                <p class="title ">Notifications : {{ notificationCount }} new</p>
                <p class="text font-m " role="button" (click)="markAllNotificationAsRead()">Mark all as read</p>
              </div>
              <div class="notification-list">
                <div class="item" role="button" *ngFor="let notification of notificationList">
                  <div class="noti-img">
                    <img
                    *ngIf="notification?.created_by_imageurl != null"
                      [src]="
                           notification?.created_by_imageurl | uploadUrl
                      "
                      alt=""
                    />

                    <img
                    *ngIf="notification?.created_by_imageurl == null || notification?.created_by_imageurl == ''"
                      src="assets/app-assets/icomoon/svg/person-circle.svg"
                      alt=""
                    />
                    <span></span>
                  </div>
                  <div (click)="markAsRead(notification.assigned_notification_id)">
                    <p class="text noti-title">
                      {{ notification.message }}
                    </p>
                    <p class="text fs-12 clr-light2">
                      Sent at
                      {{ notification.created_date | date : 'MM/dd/yyyy' }}
                      by
                      <span class="clr-primary">{{ notification.createdby }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class=" mt-2 pt-2 border-top-1 border-50 text-center">
                <a href="#" class="p-0" [routerLink]="['notifications']"><p class="text font-m">Voir tout</p> </a>
              </div>
            </ul>
          </li>
          <!------------------------>
          <li class="cart-panel" *ngIf="!isAdmin && !isEnterpriseSim">
            <a (click)="openPanel()">
              <i class="topbar-icon pi pi-fw pi-shopping-bag"></i>
              <span class="topbar-badge">{{ count ?? 0 }}</span>
              <!-- <span class="topbar-item-name">Notifications</span> -->
            </a>
          </li>
          <!-----------Profile-Settings------------->
          <li
            class="profile-settings "
            #profile
            [ngClass]="{
              'active-topmenuitem': appMain.activeTopbarItem === profile
            }"
            *ngIf="!isAdmin"
          >
            <a href="#" (click)="appMain.onTopbarItemClick($event, profile)">
              <ng-container *ngIf="!isAdmin">
                <img src="{{ profileImageUrl | uploadUrl }}" />
              </ng-container>

              <ng-container *ngIf="isAdmin">
                <img [src]="profileImageUrl ?? '../assets/app-assets/icomoon/svg/person-circle.svg'" alt="" />
              </ng-container>
            </a>

           <ul class="fadeInDown">
  <p *ngIf="!isAdmin && !isEnterpriseSim" class="title pb-2 mb-2">Profile settings</p>
  <li *ngIf="!isAdmin && !isEnterpriseSim" role="menuitem">
    <a href="#" [routerLink]="['profile-settings/personal-information']">
      <i class="pi pi-fw pi-user"></i>
      <span>My Profile</span>
    </a>
  </li>
              <!-- <li role="menuitem">
                                <a href="#" [routerLink]="['profile-settings/security-settings']" >
                                    <i class="pi pi-fw pi-cog"></i>
                                    <span>Account Setting</span>
                                </a>
                            </li>
                            <li role="menuitem">
                                <a href="#" >
                                    <i class="pi pi-fw pi-help"></i>
                                    <span>Help Desk</span>
                                </a>
                            </li> -->
              <hr *ngIf="!isAdmin" style=" border-color: rgba(65, 64, 66, 0.1) !important;margin: 0.5rem 0;" />
              <li role="menuitem">
                <a type="button" (click)="appMain.logout()">
                  <i class="pi pi-fw pi-sign-out"></i>
                  <span>Logout</span>
                </a>
              </li>
            </ul>
          </li>
          <!-----------User-Profile-Info------------->
          <li
  class="user-profile-info"
  #profile
  *ngIf="isAdmin"
  [ngClass]="{ 'active-topmenuitem': appMain.activeTopbarItem === profile }"
  (click)="appMain.topbarItemClick = true"               
>
  <a href="#" (click)="appMain.onTopbarItemClick($event, profile)">
    <img
      [src]="profileImageUrl ?? 'assets/app-assets/icomoon/svg/person-circle.svg'"
      alt="Profile"
    />
  </a>

  <ul class="fadeInDown text-center" (click)="appMain.topbarItemClick = true">
    <div class="img-container s-75 rounded-img mx-auto">
      <img
        [src]="profileImageUrl ?? 'assets/app-assets/icomoon/svg/person-circle.svg'"
        alt="Profile"
      />
    </div>
    <p class="title mt-2">{{ userInfo?.fullName }}</p>
    <p class="text fs-12">{{ userInfo?.userName }}</p>
    <button
      class="app-button button-link clr-primary"
      (click)="appMain.logout()"
    >
      Logout
    </button>
  </ul>
</li>

        </ul>
      </div>
    </div>

    <div class="right-overlay-panel" [ngClass]="{ 'open-panel': openpanel }">
      <div class="panel-overlay"></div>
      <div class="panel-content">
        <div class="panel-content-header">
          <p class="title font-sb clr-primary">My cart : {{ count }} articles</p>
          <button (click)="openPanel()" class="app-button app-button-icon-v2 btn-transparent-icon btn-xs panel-close">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="panel-content-body">
          <div class="cart-list-container" *ngIf="count > 0; else noItemInCart">
            <ng-container *ngFor="let package of detailCart">
              <ng-container *ngIf="package.products.length > 0">
                <div class="item">
                  <div class="item-head">
                    <p class="text clr-light2">{{ package.package_name }} / Packages</p>
                  </div>
                  <div class="item-body">
                    <div class="cart-list-items">
                      <ng-container *ngFor="let product of package.products">
                        <div class="item">
                          <p class="text clr-secondary">
                            {{ product.product_name }}
                          </p>
                          <div class="item-input-fields">
                            <div class="field mb-0 single-input-filed">
                              <p class="text fs-12">
                                {{ product.product_description }}
                              </p>
                            </div>
                          </div>
                          <button
                            (click)="basicFeatureDelete(package.package_id, product.product_id)"
                            class="app-button app-button-icon-v2 btn-transparent-icon btn-xs"
                          >
                            <i class="pi pi-trash"></i>
                          </button>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="package.addons.length > 0">
                <div class="item">
                  <div class="item-head">
                    <p class="text clr-light2">{{ package.package_name }} / Add-Ons</p>
                  </div>
                  <div class="item-body">
                    <div class="cart-list-items">
                      <ng-container *ngFor="let addon of package.addons">
                        <ng-container *ngIf="addon.addon_type == 'Only Description'">
                          <div class="item">
                            <p class="text clr-blue">
                              {{ addon.add_on_name }}
                            </p>
                            <div class="item-input-fields">
                              <div class="field mb-0 single-input-filed">
                                <p class="text fs-12">
                                  {{ addon.add_on_description }}
                                </p>
                              </div>
                            </div>
                            <button
                              (click)="optionDelete(package.package_id, addon.add_on_id)"
                              class="app-button app-button-icon-v2 btn-transparent-icon btn-xs"
                            >
                              <i class="pi pi-trash"></i>
                            </button>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="addon.addon_type == 'Description with Range'">
                          <div class="item">
                            <p class="text clr-blue">
                              {{ addon.add_on_name }}
                            </p>
                            <div class="item-input-fields">
                              <ng-container *ngIf="addon.increment">
                                <div class="field mb-0 single-input-filed">
                                  <input
                                    [(ngModel)]="addon.value"
                                    [min]="addon.min_range"
                                    [max]="addon.max_range"
                                    onkeydown="return (
                                                    event.ctrlKey || event.altKey ||
                                                    (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) ||
                                                    (95<event.keyCode && event.keyCode<106) ||
                                                    (event.keyCode==8) || (event.keyCode==9) ||
                                                    (event.keyCode>34 && event.keyCode<40) ||
                                                    (event.keyCode==46))"
                                    type="text"
                                    pInputText
                                    class="input-sm"
                                  />
                                  <p class="text fs-12">Numéros</p>
                                </div>
                                <span class="p-buttonset">
                                  <button
                                    class="p-button app-button app-button-icon-v2 btn-xs btn-white px-3 w"
                                    (click)="minus(addon, addon.min_range, addon.max_range)"
                                  >
                                    <i class="pi pi-minus"></i>
                                  </button>
                                  <button
                                    class="p-button app-button app-button-icon-v2 btn-xs btn-white px-3"
                                    (click)="plus(addon, addon.min_range, addon.max_range)"
                                  >
                                    <i class="pi pi-plus"></i>
                                  </button>
                                </span>
                              </ng-container>

                              <ng-container *ngIf="addon.dropdown">
                                <p-dropdown
                                  appendTo="body"
                                  [(ngModel)]="addon.value"
                                  placeholder="Select"
                                  [options]="addon.range"
                                >
                                </p-dropdown>
                              </ng-container>
                            </div>
                            <button
                              (click)="optionDelete(package.package_id, addon.add_on_id)"
                              class="app-button app-button-icon-v2 btn-transparent-icon btn-xs"
                            >
                              <i class="pi pi-trash"></i>
                            </button>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <div class="total">
              <p class="title">Total à payer HT</p>
              <p class="title">{{ totalAmountInFirstMonth }} Tsh</p>
            </div>
          </div>
          <ng-template #noItemInCart>
            <div>
              <p class="title pb-2 mb-2">You have no items in your cart.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  `,
    styleUrls: ['./modules/selfcare/my-cart-list/my-cart-list.component.scss'],
    standalone: false
})
export class AppTopbarComponent {
  profileImageUrl: string = '';
   isEnterpriseSim: boolean = false;
  notificationCount: number = 0;
  cart: order[];
  detailCart: Packages[];

  products: ProductDto[];
  addons: AddonsDto[];
  notificationList: any = [];
  userInfo: any;
  notificationsEnabled: boolean = false;
  topbarItemClick: boolean;
  activeTopbarItem: any;
  env: any;
  response: any;
  sumOftaxProd: number = 0;
  sumOftaxAdon: number = 0;
  isAdmin: boolean = false;
  constructor(
    public app: AppComponent,
    public appMain: AppMainComponent,
    private authServiceApi: AuthData,
    private cartService: CartService,
    private utilityService: UtilityService,
    private orderService: OrdersService,
    private notificationService: NotificationService,
    private router: Router
  ) {
     this.isEnterpriseSim = this.router.url.includes('/enterprise-sim');
       // Also listen to route changes
  this.router.events.subscribe(() => {
    this.isEnterpriseSim = this.router.url.includes('/enterprise-sim');
  });
    // Check if notifications are already enabled
    const savedToken = localStorage.getItem('device_id');
    if (savedToken) {
      this.notificationsEnabled = true;
    }
    this.utilityService.UpdatedImage.subscribe((res) => {
      this.response = res;
      if (this.response != null) {
        this.profileImageUrl = ApiConfig.admin.previewDoc + '/' + this.response?.profileName;
        localStorage.setItem('tempImg', this.profileImageUrl);
        console.log('apptopbar', this.profileImageUrl);
      } else {
        this.profileImageUrl = localStorage.getItem('tempImg');
      }
    });
    if (this.profileImageUrl == null || this.profileImageUrl == 'null' || this.profileImageUrl == '') {
      this.profileImageUrl = this.authServiceApi.getImageUrl();
      if (this.profileImageUrl.includes('undefined') || this.profileImageUrl == null) {
        this.profileImageUrl = '../assets/app-assets/icomoon/svg/person-circle.svg';
      }
    }
    this.isAdmin = this.setIsAdmin();
    this.env = environment;
  }

   setIsAdmin(): boolean {
    const role = this.authServiceApi.getRole();
    // Check if role is valid before checking for 'Admin', 'TMS', or 'CMS' or ' Sales Agent'
    return role ? ['Admin', 'TMS', 'CMS', 'Sales Agent'].includes(role) : false;
  }
  ngOnInit() {
    this.refresh();
    this.cartService.currentApprovalStageMessage.subscribe((msg) => {
      if (msg == 'Cart updated.') {
        this.refresh();
      }
    });
    this.userInfo = this.authServiceApi.getLogedInUserInfo();

    this.getNotification();

    this.calculationCost();
    this.utilityService.notifications$.subscribe(() => {
      this.getNotification();
    });

    this.utilityService.userInfo$.subscribe((data) => {});
  }

  getNotification() {
    this.orderService.getNotification().subscribe({
      next: (res) => {
        this.notificationCount = res.data.length;
        this.notificationList = res.data;
      },
    });
  }
  topbarItemClicks(event, item) {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
  }
  showNotification() {
    //this.isAdmin
  }

  markAsRead(notificationid: number) {
    this.orderService.markNotificationAsRead(notificationid).subscribe({
      next: (res) => {
        this.getNotification();
      },
    });
  }

  markAllNotificationAsRead() {
    this.orderService.markAllNotificationAsRead().subscribe({
      next: (res) => {
        this.getNotification();
      },
    });
  }

  refresh() {
    var cartObj = localStorage.getItem('cart');
    if (cartObj != null) {
      let jsonObj = JSON.parse(cartObj);
      this.cart = jsonObj.cartM as order[];
      this.detailCart = jsonObj.detailCart as Packages[];
    } else {
      this.cart = [] as order[];
      this.detailCart = [] as Packages[];
    }
    this.calculateCount();
  }

  openpanel: boolean = false;
  openPanel() {
    this.openpanel = !this.openpanel;
    if (this.openPanel) {
      var cartObj = localStorage.getItem('cart');
      if (cartObj != null) {
        let jsonObj = JSON.parse(cartObj);
        this.detailCart = jsonObj.detailCart as Packages[];
      }
    }
  }

  plus(addon, min, max) {
    var addedValue = addon.value + 1;
    if (addedValue > max) {
      return;
    } else {
      addon.value = addon.value + 1;
    }

    this.setLocalStorage();
  }

  minus(addon, min, max) {
    var subtractedValue = addon.value - 1;
    if (subtractedValue < min) {
      return;
    } else {
      addon.value = addon.value - 1;
    }

    this.setLocalStorage();
  }

  setLocalStorage() {
    var model = {
      userId: '',
      cartM: this.cart,
      detailCart: this.detailCart,
    };
    localStorage.setItem('cart', JSON.stringify(model));
    this.calculateCount();
    this.cartService.updateApprovalMessage('Cart updated.');
  }

  // count: number = 0;
  calculateCount() {
    if (this.detailCart != undefined && this.detailCart != null) {
      this.products = this.detailCart.map((x) => x.products).flat() as ProductDto[];

      this.addons = this.detailCart.map((x) => x.addons).flat() as AddonsDto[];
    }
    this.calculationCost();
  }

  get count(): number {
    if (this.detailCart != undefined && this.detailCart != null) {
      return (this.products?.length + this.addons?.length);
    }
    return 0;
  }

  basicFeatureDelete(packageId, id) {
    var smartArItem = this.cart.filter((x) => x.package_id == packageId);
    smartArItem.forEach((x) => {
      x.product_ids.forEach((element, index) => {
        if (element == id) x.product_ids.splice(index, 1);
      });
    });

    var detailArItem = this.detailCart.filter((x) => x.package_id == packageId);
    detailArItem.forEach((x) => {
      x.products.forEach((element, index) => {
        if (element.product_id == id) x.products.splice(index, 1);
      });
    });

    this.setLocalStorage();
  }

  optionDelete(packageId, id) {
    var smartArItem = this.cart.filter((x) => x.package_id == packageId);
    smartArItem.forEach((x) => {
      x.addon_ids.forEach((element, index) => {
        if (element == id) x.addon_ids.splice(index, 1);
      });
    });

    var detailArItem = this.detailCart.filter((x) => x.package_id == packageId);
    detailArItem.forEach((x) => {
      x.addons.forEach((element, index) => {
        if (element.add_on_id == id) x.addons.splice(index, 1);
      });
    });

    this.setLocalStorage();
  }

  counta: number = 0;
  calculationCost() {
    if (this.detailCart != undefined && this.detailCart != null) {
      this.products = this.detailCart.map((x) => x.products).flat() as ProductDto[];

      this.addons = this.detailCart.map((x) => x.addons).flat() as AddonsDto[];

      this.counta = this.products.length + this.addons.length;

      if (this.products != null) {
        if (this.products.length > 0) {
          this.sumOfHardwareCostProducts();
          this.sumOfSecurityDepositProducts();
          this.sumOfInstallationChargesProducts();
          this.sumOfMonthlyChargesProducts();
          this.sumOftaxProduct();
        } else {
          this.basicFeaturesCost = 0;
          this.sumOfInstallationChargesProduct = 0;
          this.sumOfMonthlyChargesProduct = 0;
          this.sumOfHardwareCostProduct = 0;
          this.sumOfSecurityDepositProduct = 0;
        }
      }

      this.basicFeaturesCost = this.sumOfHardwareCostProduct + this.sumOfSecurityDepositProduct;

      if (this.addons != null) {
        if (this.addons.length > 0) {
          this.sumOfHardwareCostAddons();
          this.sumOfSecurityDepositAddons();
          this.sumOfInstallationChargesAddOns();
          this.sumOfMonthlyChargesAddOns();
          this.sumOftaxAddons();
        } else {
          this.optionsCost = 0;
          this.sumOfInstallationChargesAddOn = 0;
          this.sumOfMonthlyChargesAddOn = 0;
          this.sumOfHardwareCostAddon = 0;
          this.sumOfSecurityDepositAddon = 0;
        }
      }

      this.optionsCost = this.sumOfHardwareCostAddon + this.sumOfSecurityDepositAddon;

      this.totalChargesWithoutTax = this.basicFeaturesCost + this.optionsCost;
      //--------------------add dynamic tax in the amount--------
      // const amount: number = this.totalChargesWithoutTax / 100;
      // const amount2: number = amount * 20;
      this.totlChargeswithTax = this.sumOftaxAdon + this.sumOftaxProd;

      this.totalSumInstallationCharges = this.sumOfInstallationChargesAddOn + this.sumOfInstallationChargesProduct;
      this.totalMonthlyProdAddonCost = this.sumOfMonthlyChargesProduct + this.sumOfMonthlyChargesAddOn;
      this.totalAmountInFirstMonth =
        this.totalChargesWithoutTax + this.totalSumInstallationCharges + this.totalMonthlyProdAddonCost;
    }

    //----------------------------payment recipt code end------------------------------------------------------------------
  }

  sumOfHardwareCostProduct: number;
  sumOfSecurityDepositProduct: number;
  sumOfInstallationChargesProduct: number = 0;
  sumOfMonthlyChargesProduct: number;
  basicFeaturesCost: number;

  sumOfHardwareCostAddon: number;
  sumOfSecurityDepositAddon: number;
  sumOfInstallationChargesAddOn: number = 0;
  sumOfMonthlyChargesAddOn: number = 0;
  optionsCost: number;

  totalChargesWithoutTax: number;
  totlChargeswithTax: number;
  totalSumInstallationCharges: number;

  totalAmountInFirstMonth: number;
  totalMonthlyProdAddonCost: number;

  //-------------------products sum------------------
  sumOfHardwareCostProducts() {
    this.sumOfHardwareCostProduct = this.products
      .map((a) => a.hardware_cost)
      .reduce(function (a, b) {
        return a + b;
      });
  }

  sumOfSecurityDepositProducts() {
    this.sumOfSecurityDepositProduct = this.products
      .map((a) => a.security_deposit)
      .reduce(function (a, b) {
        return a + b;
      });
  }

  sumOfInstallationChargesProducts() {
    this.sumOfInstallationChargesProduct = this.products
      .map((a) => a.installation_charges)
      .reduce(function (a, b) {
        return a + b;
      });
  }

  sumOfMonthlyChargesProducts() {
    this.sumOfMonthlyChargesProduct = this.products
      .map((a) => a.monthly_recurring_charges)
      .reduce(function (a, b) {
        return a + b;
      });
  }
  //---------------------addons sum------------------

  sumOfHardwareCostAddons() {
    this.sumOfHardwareCostAddon = this.addons
      .map((a) => a.hardware_cost)
      .reduce(function (a, b) {
        return a + b;
      });
  }

  sumOfSecurityDepositAddons() {
    this.sumOfSecurityDepositAddon = this.addons
      .map((a) => a.security_deposit)
      .reduce(function (a, b) {
        return a + b;
      });
  }

  sumOfInstallationChargesAddOns() {
    this.sumOfInstallationChargesAddOn = this.addons
      .map((a) => a.installation_charges)
      .reduce(function (a, b) {
        return a + b;
      });
  }

  sumOfMonthlyChargesAddOns() {
    this.sumOfMonthlyChargesAddOn = this.addons
      .map((a) => a.monthly_recurring_charges)
      .reduce(function (a, b) {
        return a + b;
      });
  }
  sumOftaxAddons() {
    this.sumOftaxAdon = this.addons
      .map((a) => a.addon_vat_withCeiling)
      .reduce(function (a, b) {
        return a + b;
      });
    //console.log("sumOfMonthlyChargesAddOn:  "+this.sumOfMonthlyChargesAddOn);
  }

  sumOftaxProduct() {
    this.sumOftaxProd = this.products
      .map((a) => a.product_vat_withCeiling)
      .reduce(function (a, b) {
        return a + b;
      });
    //console.log("sumOfMonthlyChargesAddOn:  "+this.sumOfMonthlyChargesAddOn);
  }
  @Output() topbartoggleSidebar = new EventEmitter<void>();
  handleTobbarSidebarToggle(){
    this.topbartoggleSidebar.emit()
  }
}
